export const NAME = 'searchTool';
